/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-09-29 21:56:26
 */

const appBase = {
  namespaced: true,
  state: {
    appBaseURL: process.env.VUE_APP_BASE_API || '',
    appRootPath: 'baseService',
    userInfo: {
      profilePicture: ''
    }
  },
  mutations: {
    UPDATE_STATE: (state, payload) => {
      const {
        key,
        value
      } = payload
      
      state[key] = value 
    }
  },
  actions: {
    updateState: ({ commit }, payload) => {
      commit('UPDATE_STATE', payload)
    },
  },
  getters: {
  }
}

export default appBase